module.exports = __webpack_public_path__ + "static/media/fasting-status-eating.67b8d5bf.svg";